import { getSangjoQuotationRequestExists } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";

import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import { Box } from "@chakra-ui/react";
import { VStack } from "goi_common";

import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import AllQuotationRequestClosedVersion from "./components/MatchRequest/AllQuotationRequest/AllQuotationRequestClosedVersion";

import useRouterChangeLoad from "./hooks/useRouterChangeLoad";

export default function MatchRequestContainer() {
  const isLoggedIn = useRecoilValue(isLoggedInState);

  useRouterChangeLoad();

  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  useEffect(() => {
    if (isLoggedIn) {
      getSangjoQuotationRequestExists().then((res) => {
        if (res.request_exists) {
          onOpenRequestExistModal(res.first_quotation_id);
        }
      });
    }
  }, [isLoggedIn]);

  return (
    <VStack alignItems="center">
      <VStack id="wrapper" width="100%" maxWidth="480px">
        <VStack>
          <Box className="head_24_b gray900" padding="20px 24px">
            상조 피해 고객
            <br />
            장례 준비 도움받기
          </Box>
          <Box className="subtitle_14_b gray900" padding="0 24px 32px">
            장례 준비로 또 다시 상처를 드릴 순 없습니다.
            <br />
            고객님의 상황에 알맞게 합리적인 장례 준비를 도와드리겠습니다.
          </Box>
        </VStack>
        <AllQuotationRequestClosedVersion />
      </VStack>
    </VStack>
  );
}
